module.exports = __webpack_public_path__ + "img/play.cac71d49.png";